export default "__VITE_ASSET__CblOnGF7__"